import React from 'react';
import { Container } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import UserTables from './UsersData/UserTables';


const Users = () => (
  <div>
    
    <Container>
      <Breadcrumbs 
        aria-label="breadcrumb"
        style={{
          marginLeft: '12px',
          marginBottom: '5px',
        }}
      >
        <Typography sx={{ color: 'text.primary' }}>Agent</Typography>
        <Typography sx={{ color: 'text.primary' }}>User Manager</Typography>
        <Typography sx={{ color: 'text.primary' }}>Users</Typography>
    
      </Breadcrumbs>
      <UserTables />
    </Container>
  </div>
  
  );

export default Users;
